const border = '1px solid red';

export default () => ({
    '& .ant-form-item-control': {
        lineHeight: 'unset',
    },
    '& .has-error .ql-toolbar': {
        borderRight: border,
        borderLeft: border,
        borderTop: border,
    },
    '& .has-error .ql-container': {
        borderRight: border,
        borderLeft: border,
        borderBottom: border,
    },
});
